import { ThemeProvider } from 'styled-components';
import GlobalFont from './typography/globalFont';
import { TucarTheme } from './theme';
import { CustomThemeProviderProps } from './types';

const CustomThemeProvider = ({ theme = TucarTheme, children }: CustomThemeProviderProps) => (
  <ThemeProvider theme={theme}>
    <GlobalFont />
    {children}
  </ThemeProvider>
);

export default CustomThemeProvider;
